export const zIndex = {
  base: 0,
  overContent: 100,
  dialogs: 1300,
};
